<!-- STEP 1: Enter Mobile Number -->
<div class="mr-container fade-in" *ngIf="step === 'mobile-number'">
    <div class="mr-header">
        <h2>{{operatorName}}</h2>
        <button class="close-btn" (click)="goBack()">
            <img src="assets/icons/close-48.png" alt="Close" />
        </button>
    </div>

    <div class="mr-body">
        <h3 class="section-label">Mobile number</h3>

        <div class="phone-input-section">
            <label class="input-label">Enter mobile number</label>
            <div class="phone-input-wrapper">
                <input type="tel" [(ngModel)]="mobileNumber" placeholder="" maxlength="10"
                    (keypress)="$event.charCode >= 48 && $event.charCode <= 57">
                <button class="contact-btn">
                    <img src="assets/icons/mobile.png" alt="Contacts" />
                </button>
            </div>
        </div>

        <div class="recent-payments-section">
            <span class="recent-label">RECENT PAYMENTS</span>
            <div class="recent-chips">
                <div class="chip" *ngFor="let item of recentPayments" (click)="selectRecentPayment(item)">
                    <span class="chip-icon">
                        <img src="assets/icons/user.png" alt="Contacts" />
                    </span>
                    <span class="chip-text">{{item}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- STEP 2: Select Plan -->
<div class="mr-container fade-in tariffs" *ngIf="step === 'tariffs'">
    <div class="mr-header">
        <h2><span class="label">Tariffs: </span><span class="value">{{operatorName}}</span></h2>
        <button class="close-btn" (click)="goBack()">
            <img src="assets/icons/close-48.png" alt="Close" />
        </button>
    </div>

    <div class="mr-body">
        <div class="plans-grid">
            <div class="plan-card" *ngFor="let plan of tariffPlans">
                <div class="plan-header-row">
                    <div class="plan-name">{{plan.name}}</div>
                    <div class="plan-desc">{{plan.description}}</div>
                </div>

                <div class="plan-details-grid">
                    <div class="detail-item">
                        <span class="detail-label">Calls</span>
                        <span class="detail-value">{{plan.calls}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">SMS</span>
                        <span class="detail-value">{{plan.sms}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Data</span>
                        <span class="detail-value">{{plan.data}}</span>
                    </div>
                </div>

                <div class="plan-footer-row">
                    <div class="price-section">
                        <span class="currency">₹</span>
                        <span class="price">{{plan.price}}</span>
                    </div>

                    <div class="meta-section">
                        <div class="meta-item">
                            <span class="meta-label">Data</span>
                            <span class="meta-value">{{plan.dataPerDay}}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">Validity</span>
                            <span class="meta-value">{{plan.validity}}</span>
                        </div>
                    </div>

                    <button class="buy-btn" (click)="selectPlan(plan)">Buy</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- STEP 3: Review -->
<ng-container *ngIf="step === 'review'">
    <div class="mrf-review-container">

        <!-- Contact pill -->
        <div class="mrf-review-contact">
            <div class="mrf-contact-avatar">
                <div class="mrf-contact-icon">
                    <img src="assets/icons/mobile-user.svg" alt="Contacts" />
                </div>
            </div>
            <div class="mrf-contact-info">
                <span class="mrf-contact-label">Mobile number</span>
                <span class="mrf-contact-num">+{{ mobileNumber }}</span>
            </div>
        </div>

        <!-- Select card -->
        <div class="mrf-review-card-box" [class.mrf-dropdown-active]="showCardDropdown">
            <p class="mrf-select-card-label">Select card</p>
            <div class="mrf-card-preview-box">
                <div class="mrf-selected-card-info">
                    <p class="mrf-selected-card-name">{{ selectedCard.name }}</p>
                    <p class="mrf-selected-card-num">**** {{ selectedCard.lastFour }}</p>
                </div>
                <button class="mrf-btn-change" (click)="toggleCardDropdown(); $event.stopPropagation()">
                    <span>Change</span>
                    <div class="mrf-arrow-wrap" [class.rotated]="showCardDropdown">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M3 5.5L7 9L11 5.5" stroke="#E7733A" stroke-width="1.6" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </button>

                <!-- Card Dropdown List -->
                <div class="mrf-card-dropdown" *ngIf="showCardDropdown" (click)="$event.stopPropagation()">
                    <div class="mrf-dropdown-header">
                        <span>Select Card</span>
                    </div>
                    <div class="mrf-dropdown-scroll">
                        <div *ngFor="let card of paymentCards" class="mrf-dropdown-item"
                            [class.mrf-item-selected]="selectedCard.lastFour === card.lastFour"
                            (click)="selectCard(card)">
                            <div class="mrf-card-icon-box">
                                <img [src]="card.icon" alt="card" onerror="this.src='assets/icons/card.svg'">
                            </div>
                            <div class="mrf-card-item-info">
                                <div class="mrf-card-name-row">
                                    <span class="mrf-card-item-name">{{ card.name }}</span>
                                    <span class="mrf-active-badge"
                                        *ngIf="selectedCard.lastFour === card.lastFour">Active</span>
                                </div>
                                <span class="mrf-card-item-num">**** {{ card.lastFour }}</span>
                            </div>
                            <div class="mrf-tick" *ngIf="selectedCard.lastFour === card.lastFour">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M3 8L6.5 11.5L13 4.5" stroke="#E7733A" stroke-width="1.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Backdrop to close dropdown -->
            <div class="mrf-dropdown-backdrop" *ngIf="showCardDropdown" (click)="showCardDropdown = false"></div>
        </div>
        <hr>
        <!-- Review summary -->
        <div class="mrf-review-summary">
            <h3 class="mrf-review-summary-title">Review</h3>
            <div class="mrf-review-row">
                <span class="mrf-review-key">Mobile number</span>
                <span class="mrf-review-val">+{{ mobileNumber }}</span>
            </div>
            <div class="mrf-review-row">
                <span class="mrf-review-key">Tariffs:</span>
                <span class="mrf-review-val">{{ selectedPlan?.name }}</span>
            </div>
            <div class="mrf-review-row">
                <span class="mrf-review-key">Fee</span>
                <span class="mrf-review-val">₹{{ fee.toFixed(2) }}</span>
            </div>
        </div>

        <!-- Buttons OUTSIDE cards -->
        <div class="mrf-footer">
            <button class="mrf-btn-back" (click)="goBack()">Cancel</button>
            <button class="mrf-btn-next active" (click)="confirm()">Send</button>
        </div>

    </div>
</ng-container>

<!-- Footer -->
<ng-container *ngIf="step === 'mobile-number'">
    <div class="mr-footer">
        <button class="btn-back" (click)="goBack()">Back</button>
        <button class="btn-next" [disabled]="!isMobileValid" (click)="goToTariffs()">Next</button>
    </div>
</ng-container>
<ng-container *ngIf="step === 'tariffs'">
    <div class="mr-footer-centered">
        <button class="btn-back-pill" (click)="goBack()">Back</button>
    </div>
</ng-container>